<template>
  <component :is="textComponent" bold class="duration text-primary">
    {{ duration }}
  </component>
</template>

<script setup>
const props = defineProps({
  size: { type: String, default: 'medium' }
})
const textComponent = computed(() => {
  if (props.size === 'large') {
    return resolveComponent('EmH3')
  }
  return resolveComponent('EmBody1')
})
const callStore = useCallStore()
const duration = computed(() => {
  const minutes = `0${Math.floor(callStore.callDuration / 60)}`.slice(-2)
  const seconds = `0${callStore.callDuration % 60}`.slice(-2)
  return `${minutes}:${seconds}`
})
</script>
